import { Button } from "components/ui/button";
import { Color } from "utils/theme";
import { UsbTransferStates } from "./usb-transfer-modal";
import { Trans, useTranslation } from "react-i18next";
import { TriangleAlert } from "lucide-react";

export const ErrorState = ({ error, setScreenState, onClose }) => {
  const { t } = useTranslation();

  return (
    <section className="flex flex-col justify-center items-center">
      <TriangleAlert
        className="w-16 h-16 my-4"
        style={{ color: Color.Rose[500] }}
      />
      <p
        className="mb-2 max-w-sm text-center"
        style={{ color: Color.Rose[500] }}
      >
        <Trans
          i18nKey={
            "settings.general_settings.usb_data_transfer.error_modal.description"
          }
        >
          An error occurred while transferring the data. Please try again.
        </Trans>
      </p>
      {error?.message && (
        <p
          className="text-center max-w-[600px]"
          style={{ color: Color.Primary[400] }}
        >
          {error?.message}
        </p>
      )}
      <Button
        onClick={() => {
          setScreenState(UsbTransferStates.Start);
          onClose();
        }}
        className="w-full mt-5"
        variant="secondary"
      >
        {t("common.close")}
      </Button>
    </section>
  );
};
